import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAllAccountsForPrimaryNavPanelQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllAccountsForPrimaryNavPanelQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id: string, accounts: { __typename?: 'UserAccountDataConnection', nodes: Array<{ __typename?: 'UserAccountData', account: { __typename?: 'Account', id: string, displayName?: string | null, imageUrl?: string | null, version?: number | null } }> }, inboxAccounts?: { __typename?: 'InboxAccountConnection', nodes: Array<{ __typename?: 'InboxAccount', id?: string | null, displayName?: string | null, imageUrl?: string | null, version?: number | null }> } | null } | { __typename?: 'IdentifiedUser', id: string } | null };


export const GetAllAccountsForPrimaryNavPanel = /*#__PURE__*/ gql`
    query GetAllAccountsForPrimaryNavPanel {
  me {
    id
    ... on AuthenticatedUser {
      accounts(page: {first: 500}, order: {direction: ASC, field: DISPLAY_NAME}) {
        nodes {
          account {
            id
            displayName
            imageUrl
            version
          }
        }
      }
      inboxAccounts(page: {first: 500}) {
        nodes {
          id
          displayName
          imageUrl
          version
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAllAccountsForPrimaryNavPanelQuery, GetAllAccountsForPrimaryNavPanelQueryVariables>;

          

          export const useGetAllAccountsForPrimaryNavPanelQuery = (options?:QueryHookOptions<GetAllAccountsForPrimaryNavPanelQuery, GetAllAccountsForPrimaryNavPanelQueryVariables>) => useQuery(GetAllAccountsForPrimaryNavPanel, options);

          

          export type GetAllAccountsForPrimaryNavPanelQueryOptions = QueryHookOptions<GetAllAccountsForPrimaryNavPanelQuery, GetAllAccountsForPrimaryNavPanelQueryVariables>;

          

          export const useGetAllAccountsForPrimaryNavPanelLazyQuery = (options?:LazyQueryHookOptions<GetAllAccountsForPrimaryNavPanelQuery, GetAllAccountsForPrimaryNavPanelQueryVariables>) => useLazyQuery(GetAllAccountsForPrimaryNavPanel, options);

          

          export type GetAllAccountsForPrimaryNavPanelQueryResult = ReturnType<typeof useGetAllAccountsForPrimaryNavPanelQuery>;

          
